<div class="form-layout-compact">
    @if (displayField) {
        @if (displayField.type === "field" && fieldSpec)  {
            @if (fieldSpec.sort || spec.implementsColumnarView) {
                <div class="lm-builder-flex-column">
                    <div class="field">
                        <input
                                id="lm-builder-display-field-default-sort"
                                name="lm-builder-display-field-default-sort"
                                data-automation-id="lm-builder-display-field-default-sort-input"
                                soho-checkbox
                                type="checkbox"
                                soho-trackdirty
                                [(ngModel)]="defaultSort"
                                (change)="updateDisplayFieldSort()">
                        <label [forCheckBox]="true" soho-label for="lm-builder-display-field-default-sort">{{ 'ListPersonalizationDefaultSortLabel40' | translate }}</label>
                    </div>
                    <div class="field">
                        <input
                                id="lm-builder-display-field-default-sort-descending"
                                name="lm-builder-display-field-default-sort-descending"
                                data-automation-id="lm-builder-display-field-default-sort-descending-input"
                                soho-checkbox
                                type="checkbox"
                                soho-trackdirty
                                [disabled]="!defaultSort"
                                [(ngModel)]="defaultSortDescending"
                                (change)="updateDisplayFieldSort()">
                        <label [forCheckBox]="true" soho-label for="lm-builder-display-field-default-sort-descending">{{ 'ListPersonalizationSortDescendingLabel40' | translate }}</label>
                    </div>
                </div>
            }
            @if(!spec.implementsColumnarView) {
                @if (fieldSpec.sort && setSpec) {
                    <label class="lm-bold">{{sortSetLabel}}</label>
                    <div class="tags-wrapper">
                        @for (field of setSpec.sortFields; track field.name; let i = $index) {
                            <div class="tag-container">
                                <div class="tag">
                                <span soho-tooltip [content]="field.name">{{ field.name }}
                                    @if (field.descending) {
                                        <svg soho-icon class="lm-facade-sort-icon" [icon]="'sort-z-to-a'" soho-tooltip [content]="'Descending' | translate"/>
                                    }
                                </span>
                                </div><br>
                            </div>
                        }
                    </div>
                } @else {
                    <div class="lm-builder-flex-column-toolbar">
                        <button soho-button="tertiary" data-automation-id="lm-builder-display-field-add-sort-btn" icon="add" (click)="addSort()">{{ 'Add' | translate }}</button>
                    </div>
               }
            }
        }
        @if(!spec.implementsColumnarView && fieldSpec.sort) {
            <div class="lm-builder-flex-column-toolbar">
                <button soho-button="tertiary" data-automation-id="lm-builder-display-field-remove-sort-btn" icon="close-small" (click)="removeSort()">{{ 'Remove' | translate }}</button>
                <button soho-button="tertiary" data-automation-id="lm-builder-display-field-edit-sort-btn"  icon="{{ setSpec? 'edit' : 'add' }}"(click)="editSort()">{{ setSpec? ('Edit' | translate) : ('Add' | translate) }}</button>
            </div>
        }
    }
</div>
